/* Somnair — cart bundle quantity sync.
   The "Complete Quiet-Nights Program" is added as 5 separate line items (device +
   4 bonuses). Their quantities can drift apart: a shopper reduced the device to 1 but
   the bonuses stayed at 4, so checkout showed the wrong totals. The bonus lines have
   their qty stepper + remove control hidden (somnair-cart-lock.css), so the only
   editable quantity is the DEVICE. This script mirrors the 4 bonus quantities onto the
   device quantity after any cart mutation, and removes the bonuses if the device leaves
   the cart — their free price depends on the device being present (the store's automatic
   discount has a min-subtotal guard), so orphan bonuses would be charged full price.
   It also heals a pre-existing desynced cart on page load.

   Why fetch-interception: Shrine's cart pub/sub (PUB_SUB_EVENTS.cartUpdate) is
   module-scoped in the obfuscated main.js and not reachable from an external asset, and
   Dawn dispatches no bubbling DOM event for it. Patching window.fetch is the only hook
   that catches every mutation path (drawer stepper, cart-page stepper, remove, add).
   Repaint replicates the theme's renderContents WITHOUT calling open(), so a silent
   reconcile (on-load heal, background tab) never pops the drawer open. */
(function () {
  'use strict';
  if (window.__somnairCartSync) return;
  window.__somnairCartSync = true;
  if (window.Shopify && window.Shopify.designMode) return; // no-op in the theme editor

  var DEVICE_HANDLE = 'somnair-quiet-nights-kit';
  var BONUS_HANDLES = [
    '4-month-patches-supply-included',
    'lifetime-warranty-vip-support',
    'string-for-better-patch-support',
    'shipping-protection'
  ];

  var running = false, pending = false, timer = null;

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function isCartPage() {
    return !!document.querySelector('cart-items') || /(^|\/)cart\/?$/.test(window.location.pathname);
  }

  // Repaint the drawer the way the theme's renderContents does, minus open().
  function paintDrawer(sections, itemCount) {
    try {
      var host = document.getElementById('CartDrawer');
      if (host && sections['cart-drawer']) {
        var src = parse(sections['cart-drawer']).querySelector('#CartDrawer');
        if (src) host.innerHTML = src.innerHTML;
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        var sb = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (sb) bubble.innerHTML = sb.innerHTML;
      }
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) drawerEl.classList.toggle('is-empty', itemCount === 0);
    } catch (e) { /* leave the DOM as-is on any parse failure */ }
  }

  function reconcile() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items) return;
      var Qd = 0, hasBonus = false;
      cart.items.forEach(function (i) {
        if (i.handle === DEVICE_HANDLE) Qd += i.quantity;
        if (BONUS_HANDLES.indexOf(i.handle) !== -1) hasBonus = true;
      });
      if (!hasBonus) return; // no bundle bonus in the cart -> nothing to do
      var target = Qd > 0 ? Qd : 0; // device gone -> remove bonuses (set to 0)
      var updates = {}, needed = false;
      cart.items.forEach(function (i) {
        if (BONUS_HANDLES.indexOf(i.handle) !== -1 && i.quantity !== target) {
          updates[i.key] = target; // key by line-item key: unambiguous
          needed = true;
        }
      });
      if (!needed) return;
      // '__smpsync' marks our own writes so the fetch patch below ignores them.
      if (isCartPage()) {
        return fetch('/cart/update.js?__smpsync=1', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      }
      return fetch('/cart/update.js?__smpsync=1', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data && data.sections) paintDrawer(data.sections, data.item_count);
      });
    });
  }

  function run() {
    running = true;
    reconcile().catch(function () {}).then(function () {
      running = false;
      if (pending) { pending = false; schedule(); }
    });
  }
  // Debounce (rapid +/+/+) + single-flight (never two reconciles at once).
  function schedule() {
    if (running) { pending = true; return; }
    clearTimeout(timer);
    timer = setTimeout(run, 180);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var a0 = arguments[0];
      var url = typeof a0 === 'string' ? a0 : (a0 && a0.url) || '';
      if (CART_MUTATION.test(url) && url.indexOf('__smpsync') === -1) {
        // Fire-and-forget: only inspect r.ok, never read the body (the theme's own
        // handler consumes it). Then schedule a reconcile off a fresh /cart.js.
        p.then(function (r) { if (r && r.ok) schedule(); }).catch(function () {});
      }
    } catch (e) { /* never break the original request */ }
    return p;
  };

  // Heal a pre-existing desynced cart on load (e.g. device 1 / bonuses 4).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
